// import MiniCalendar from "components/calendar/MiniCalendar";
import ReportsWithType from "views/admin/default/components/ReportsWithType";
import TotalNotes from "views/admin/default/components/TotalNotes";
// import PieChartCard from "views/admin/default/components/PieChartCard";
import { IoDocuments } from "react-icons/io5";
import { MdBarChart, MdTimer, MdPeople, MdSubscriptions, MdFileOpen } from "react-icons/md";

import Widget from "components/widget/Widget";
import { useEffect, useState } from "react";
import { getAnalytics, getYearlyReport, getYearlyReportByType } from "api";
// import CheckTable from "views/admin/default/components/CheckTable";
// import ComplexTable from "views/admin/default/components/ComplexTable";
// import DailyTraffic from "views/admin/default/components/DailyTraffic";
// import TaskCard from "views/admin/default/components/TaskCard";
// import tableDataCheck from "./variables/tableDataCheck";
// import tableDataComplex from "./variables/tableDataComplex";

interface analyticsModel {
  OnTrials: number,
  Subscriptions: number,
  TMembers: number,
  TNotes: number
}

interface reportsByTypeModel {
  subscribed: number[] | boolean,
  trial: number[] | boolean
}

const Dashboard = () => {
  const [analytics, setAnalytics] = useState<analyticsModel>({
    OnTrials: 0,
    Subscriptions: 0,
    TMembers: 0,
    TNotes: 0
  })

  const [yearlyReport, setYearlyReport] = useState<any[]>()

  const [allReports, setAllReports] = useState<number[]>()
  const [allCount, setAllCount] = useState<number>()
  const [reportsByType, setReportsByType] = useState<reportsByTypeModel>({
    subscribed:false,
    trial: false
  })

  const getData = async () => {
    const filters = {
      OnTrials: true,
      Subscriptions: true,
      TMembers: true,
      TNotes: true
    }
    const data = await getAnalytics(filters)
    setAnalytics(data.response)

    const reportsGlobal = await getYearlyReport(2026)
    setAllReports(reportsGlobal.response.data)
    setAllCount(reportsGlobal.response.count)

    const reportsByType = await getYearlyReportByType(2026)
    setReportsByType(reportsByType.response)

  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <div>
      {/* Card widget */}

      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-2 3xl:grid-cols-6">
        <Widget
          icon={<MdTimer className="h-7 w-7" />}
          title={"On Trials"}
          subtitle={analytics.OnTrials}
        />

        <Widget
          icon={<MdSubscriptions className="h-6 w-6" />}
          title={"Subscriptions"}
          subtitle={analytics.Subscriptions}
        />
        <Widget
          icon={<MdPeople className="h-7 w-7" />}
          title={"Total Members"}
          subtitle={analytics.TMembers}
        />
        <Widget
          icon={<MdFileOpen className="h-6 w-6" />}
          title={"Total Notes"}
          subtitle={analytics.TNotes}
        />
      </div>

      {/* Charts */}

      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        <TotalNotes data={allReports} count={allCount} />
        <ReportsWithType data={reportsByType}/>

      </div>

      {/* <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
        <div>
          <CheckTable tableData={tableDataCheck} />
        </div>

        <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <DailyTraffic />
          <PieChartCard />
        </div>

        <ComplexTable tableData={tableDataComplex} />

        <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
          <TaskCard />
          <div className="grid grid-cols-1 rounded-[20px]">
            <MiniCalendar />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Dashboard;
